"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const AvatarField = _ref => {
  let {
    record,
    source,
    size,
    className
  } = _ref;
  return record ? /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    src: "".concat(record[source], "?size=").concat(size, "x").concat(size),
    style: {
      width: parseInt(size, 10),
      height: parseInt(size, 10)
    },
    className: className
  }) : null;
};

AvatarField.defaultProps = {
  size: '25',
  source: 'picture'
};
AvatarField.propTypes = {
  record: _propTypes.default.string,
  source: _propTypes.default.string,
  size: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = AvatarField;
exports.default = _default;